import React, { useEffect, useState } from "react";
import {
  FaTrash,
  FaInfoCircle,
  FaUpload,
  FaCalculator,
  FaShieldAlt,
} from "react-icons/fa";
import { FiShield } from "react-icons/fi";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import "./ViewBidOnly.scss";
import { hitUploadMedia } from "../../../Redux/Common/UploadMediaSlice";
import { hitUpdateBidProfessionalApi } from "../../../Redux/Professional/BidUpdateProfessionalSlice";
import { useNavigate } from "react-router-dom";
import { hitGetBoostBidProfessionalApi } from "../../../Redux/Professional/GetBoostBidsSlice";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { FaStar, FaCheckCircle } from "react-icons/fa";
import { useSelector } from "react-redux";
import { timeAgo } from "../../../Helper/CommonFunctions";
import { all } from "axios";
import BoostYourBid from "../../../assets/img/Boost Your Bid.svg";
import boostBtn from "../../../assets/img/Boost btn.svg";

const ViewBidOnly = ({ jobData }) => {
  //console.log("jobData in ViewBidOnly", jobData);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [bid, setBid] = useState(1);
  const [boostBidPoints, setBoostBidPoints] = useState(0);
  const [credits, setCredits] = useState(75);
  const [wantToBoostBid, setWantToBoostBid] = useState(false);
  const [boostBidsData, setBoostBidsData] = useState([]);

  const [discount, setDiscount] = useState(0);
  const [tax, setTax] = useState(0);

  const [discount1, setDiscount1] = useState(0);
  const [tax1, setTax1] = useState(0);

  const [discount2, setDiscount2] = useState(0);
  const [tax2, setTax2] = useState(0);

  const [customerMessage, setCustomerMessage] = useState("");
  const [requiredDeposit, setRequiredDeposit] = useState(0);
  const [bidExpiry, setBidExpiry] = useState("");
  const [financing, setFinancing] = useState(0);
  const [priceType, setPriceType] = useState(
    jobData
      ? jobData.bidData?.priceType == 1
        ? "guaranteed"
        : "estimated"
      : "guaranteed"
  );
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [isDisabled, setIsDisabled] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const [deletedIndexes, setDeletedIndexes] = useState([]);

  const [images, setImages] = useState([
    "https://simplerenovate.s3.us-east-1.amazonaws.com/1763563807127IMG_20251119_201937.jpg",
    "https://simplerenovate.s3.us-east-1.amazonaws.com/1756185746134promo_image_0.jpeg",
    "https://images.unsplash.com/photo-1560807707-8cc77767d783?w=400",
  ]);

  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      navigation("/professional/login");
    } else {
      // dispatch(hitGetBoostBidProfessionalApi(jobData._id));
    }
  }, []);

  const [lineItems, setLineItems] = useState([
    {
      id: 1,
      product: "",
      description: "",
      quantity: 1,
      unitPrice: 0,
      price: 0,
    },
  ]);

  const [lineItems1, setLineItems1] = useState([
    {
      id: 1,
      product: "",
      description: "",
      quantity: 1,
      unitPrice: 0,
      price: 0,
    },
  ]);

  const [lineItems2, setLineItems2] = useState([
    {
      id: 1,
      product: "",
      description: "",
      quantity: 1,
      unitPrice: 0,
      price: 0,
    },
  ]);

  useEffect(() => {
    //console.log("jobData changed", jobData.bidData);
    if (jobData) {
      const allOptions = jobData.bidData.options;
      //  //console.log("allOptions", allOptions.length);
      if (allOptions && allOptions.length > 0) {
        const option1 = allOptions.find((option) => option.optionType == 1);
        if (option1) {
          const itemsWithId = option1.items.map((item, index) => ({
            ...item,
            id: index + 1,
          }));
          ////console.log("itemsWithId", itemsWithId);
          setLineItems(itemsWithId);
          setDiscount(option1.discountPercentage || 0);
        }
        const option2 = allOptions.find((option) => option.optionType == 2);
        if (option2) {
          const itemsWithId = option2.items.map((item, index) => ({
            ...item,
            id: index + 1,
          }));
          setLineItems1(itemsWithId);
          setDiscount1(option2.discountPercentage || 0);
        }
        const option3 = allOptions.find((option) => option.optionType == 3);
        if (option3) {
          const itemsWithId = option3.items.map((item, index) => ({
            ...item,
            id: index + 1,
          }));
          setLineItems2(itemsWithId);
          setDiscount2(option3.discountPercentage || 0);
        }

        setCustomerMessage(jobData.bidData.message);
        setRequiredDeposit(jobData.bidData.requiredDeposit);
        setBidExpiry(jobData.bidData.expireAt);
        setFinancing(jobData.bidData.financing);
      }
    }
  }, [jobData]);

  // Calculate totals
  const calculateSubTotal = () => {
    return lineItems.reduce((sum, item) => {
      return sum + item.quantity * item.unitPrice;
    }, 0);
  };

  const subTotal = calculateSubTotal();
  const discountAmount = (subTotal * discount) / 100;
  const finalTotal = subTotal - discountAmount + tax;

  // Calculate totals
  const calculateSubTotal1 = () => {
    return lineItems1.reduce((sum, item) => {
      return sum + item.quantity * item.unitPrice;
    }, 0);
  };

  const subTotal1 = calculateSubTotal1();
  const discountAmount1 = (subTotal1 * discount1) / 100;
  const finalTotal1 = subTotal1 - discountAmount1 + tax1;

  // Calculate totals
  const calculateSubTotal2 = () => {
    return lineItems2.reduce((sum, item) => {
      return sum + item.quantity * item.unitPrice;
    }, 0);
  };

  const subTotal2 = calculateSubTotal2();
  const discountAmount2 = (subTotal2 * discount2) / 100;
  const finalTotal2 = subTotal2 - discountAmount2 + tax2;

  return (
    <div className="project-details">
      {/* Header */}
      <div className="pd-header">
        <h3>
          <span className="highlight"></span> &gt; View Bid for Job
          {` ${jobData ? jobData.jobId : ""}`}{" "}
        </h3>
      </div>

      <div className="pd-images">
        {/* <label>
          Options{" "}
          <input
            type="checkbox"
            disabled={isDisabled}           
          />
          <span>Opt out</span>
        </label> */}
        <div className="image-grid">
          <div
            //key={index}
            className={`image-item ${selectedIndex === 0 ? "selected" : ""}`}
            onClick={() => setSelectedIndex(0)}
          >
            <img src={images[0]} alt="project" />
          </div>
        </div>
      </div>

      {/* Option good */}
      {/* Line Items */}
      {selectedIndex === 0 && (
        <>
          <div className="pd-line-items">
            <h6>Products/service</h6>
            {lineItems.map((item, index) => (
              <div className="line-item" key={item.id}>
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Line Item {index + 1}</h5>
                </div>

                <label>Product/service</label>
                <input type="text" value={item.product} readOnly />

                <label>Description</label>
                <textarea type="text" value={item.description} readOnly />

                <div className="line-pricing">
                  <div>
                    <label>Quantity</label>
                    <input type="number" value={item.quantity} readOnly />
                  </div>
                  <div>
                    <label>Unit Price</label>
                    <input type="text" value={`$ ${item.unitPrice}`} readOnly />
                  </div>
                  <div>
                    <label>Line Total</label>
                    <input
                      type="text"
                      value={`$${(item.quantity * item.unitPrice).toFixed(2)}`}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="add-more-section">
            {/* <button className="add-more-btn" onClick={addLineItem}>
              <span className="plus-icon">+</span> Add More
            </button> */}
          </div>
          <div className="pricing-summary">
            <h4>Pricing Summary</h4>

            <div className="summary-row">
              <span className="label">Sub Total:</span>
              <span className="value">${subTotal.toFixed(2)}</span>
            </div>

            <div className="summary-row discount-row">
              <span className="label">Discount (%):</span>
              <div className="discount-input-wrapper">
                <input
                  type="text"
                  value={discount}
                  readOnly
                  className="discount-input"
                  max="100"
                  min="0"
                />
                <span className="percent-symbol">%</span>
              </div>
              <span className="value discount-value">
                -${discountAmount.toFixed(2)}
              </span>
            </div>

            <div className="summary-row">
              <span className="label">Tax:</span>
              <span className="value">${tax.toFixed(2)}</span>
            </div>

            <div className="summary-row final-row">
              <span className="label">Final Total:</span>
              <span className="value final-value">
                ${finalTotal.toFixed(2)}
              </span>
            </div>
          </div>
        </>
      )}

      {/* Option Better */}
      {/* Line Items */}
      {selectedIndex === 1 && (
        <>
          <div className="pd-line-items">
            <h6>Products/service</h6>
            {lineItems1.map((item, index) => (
              <div className="line-item" key={item.id}>
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Line Item {index + 1}</h5>
                </div>

                <label>Product/service</label>
                <input type="text" value={item.product} readOnly />

                <label>Description</label>
                <textarea type="text" value={item.description} readOnly />

                <div className="line-pricing">
                  <div>
                    <label>Quantity</label>
                    <input type="text" value={item.quantity} readOnly />
                  </div>
                  <div>
                    <label>Unit Price</label>
                    <input type="text" value={`$ ${item.unitPrice}`} readOnly />
                  </div>
                  <div>
                    <label>Line Total</label>
                    <input
                      type="text"
                      value={`$${(item.quantity * item.unitPrice).toFixed(2)}`}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="add-more-section"></div>
          <div className="pricing-summary">
            <h4>Pricing Summary</h4>

            <div className="summary-row">
              <span className="label">Sub Total:</span>
              <span className="value">${subTotal1.toFixed(2)}</span>
            </div>

            <div className="summary-row discount-row">
              <span className="label">Discount (%):</span>
              <div className="discount-input-wrapper">
                <input
                  type="text"
                  value={discount1}
                  readOnly
                  className="discount-input"
                  max="100"
                  min="0"
                />
                <span className="percent-symbol">%</span>
              </div>
              <span className="value discount-value">
                -${discountAmount1.toFixed(2)}
              </span>
            </div>

            <div className="summary-row">
              <span className="label">Tax:</span>
              <span className="value">${tax1.toFixed(2)}</span>
            </div>

            <div className="summary-row final-row">
              <span className="label">Final Total:</span>
              <span className="value final-value">
                ${finalTotal1.toFixed(2)}
              </span>
            </div>
          </div>
        </>
      )}

      {/* Option Best */}
      {/* Line Items */}
      {selectedIndex === 2 && (
        <>
          <div className="pd-line-items">
            <h6>Products/service</h6>
            {lineItems2.map((item, index) => (
              <div className="line-item" key={item.id}>
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Line Item {index + 1}</h5>
                </div>

                <label>Product/service</label>
                <input type="text" value={item.product} readOnly />

                <label>Description</label>
                <textarea type="text" value={item.description} readOnly />

                <div className="line-pricing">
                  <div>
                    <label>Quantity</label>
                    <input type="text" value={item.quantity} readOnly />
                  </div>
                  <div>
                    <label>Unit Price</label>
                    <input type="text" value={`$ ${item.unitPrice}`} readOnly />
                  </div>
                  <div>
                    <label>Line Total</label>
                    <input
                      type="text"
                      value={`$${(item.quantity * item.unitPrice).toFixed(2)}`}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="add-more-section"></div>
          <div className="pricing-summary">
            <h4>Pricing Summary</h4>

            <div className="summary-row">
              <span className="label">Sub Total:</span>
              <span className="value">${subTotal2.toFixed(2)}</span>
            </div>

            <div className="summary-row discount-row">
              <span className="label">Discount (%):</span>
              <div className="discount-input-wrapper">
                <input
                  type="text"
                  value={discount2}
                  readOnly
                  className="discount-input"
                  max="100"
                  min="0"
                />
                <span className="percent-symbol">%</span>
              </div>
              <span className="value discount-value">
                -${discountAmount2.toFixed(2)}
              </span>
            </div>

            <div className="summary-row">
              <span className="label">Tax:</span>
              <span className="value">${tax2.toFixed(2)}</span>
            </div>

            <div className="summary-row final-row">
              <span className="label">Final Total:</span>
              <span className="value final-value">
                ${finalTotal2.toFixed(2)}
              </span>
            </div>
          </div>
        </>
      )}

      {/* Additional Details Section */}
      <div className="additional-details">
        <h4>Additional Details</h4>

        {/* Customer Message */}
        <div className="form-group">
          <label>Customer Message</label>
          <textarea
            className="customer-message"
            value={customerMessage}
            readOnly
            rows="4"
          />
        </div>

        {/* Required Deposit and Bid Expiry */}
        <div className="two-column">
          <div className="form-group">
            <label>Required Deposit</label>
            <input type="text" value={`$ ${requiredDeposit}`} readOnly />
          </div>
          <div className="form-group">
            <label>Bid Expiry</label>
            <input type="text" value={bidExpiry} readOnly />
          </div>
        </div>

        {/* Financing */}
        <div className="form-group">
          <label>Financing (optional)</label>
          <input type="text" value={`$${financing}/month`} readOnly />
        </div>

        {/* Attachments */}
        <div className="form-group attachments">
          <label>Attachments</label>
          <p className="helper-text">
            Upload documents, images or PDFs to support your bid.
          </p>
          <div className="upload-area">
            <FaUpload className="upload-icon" />
            <p>Drop files here or click to upload</p>
            <input
              type="file"
              multiple
              style={{ display: "none" }}
              id="file-upload"
            />
          </div>
          {uploadedFiles.length > 0 && (
            <div className="uploaded-files">
              {uploadedFiles.map((file, index) => (
                <span key={index} className="file-tag">
                  {file.name}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Price Type Selection */}
      <div className="price-type-selection">
        <h4>Select one of the following:</h4>

        <div className="radio-group">
          <label className="radio-option">
            <input
              type="radio"
              name="priceType"
              value="guaranteed"
              checked={priceType === "guaranteed"}
              readOnly
            />
            <FiShield className="price-icon shield-icon" />
            <span>Guaranteed Price</span>
            <FaInfoCircle className="info-icon" />
          </label>

          <label className="radio-option">
            <input
              type="radio"
              name="priceType"
              value="estimated"
              checked={priceType === "estimated"}
              readOnly
            />
            <FaCalculator className="price-icon calculator-icon" />
            <span>Estimated Price</span>
            <FaInfoCircle className="info-icon" />
          </label>
        </div>
      </div>
    </div>
  );
};

export default ViewBidOnly;
